<template>
    <div class="top_message--warning">
        <div class="row align-items-center">
            <div class="col">
                <i class="mdi mdi-alert"></i>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class TopWarning extends Vue {
    name = 'top_warning';
}

Vue.component('top_warning', TopWarning);
</script>
